import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Page from '../components/layouts/Page';
import { Link } from 'gatsby';
import SEO from '../components/seo';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Page;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEO title="About" mdxType="SEO" />
    <h1>{`About GraphUp`}</h1>
    <p>{`GraphUp is an online diagram builder that let's you create all sorts
of `}<abbr title="Unified Modeling Language">{`UML`}</abbr>{` diagrams by writing code instead
of using slow and frustrating apps like Power-Point or Google draw.`}</p>
    <p>{`GraphUp is a modern alternative to those approaches that will transform the way you build graphs.`}</p>
    <h2>{`How to create diagrams?`}</h2>
    <p>{`With GraphUp you can build `}<Link to="/sequence-diagram" mdxType="Link">{`sequence diagrams`}</Link>{`
and `}<Link to="/gantt-diagram" mdxType="Link">{`Gantt diagrams`}</Link>{` right from your browser using the free online editor.`}</p>
    <p>{`If you'd like to build more diagrams please `}<a rel="nofollow" href="https://nicolaskeller.typeform.com/to/HsLUBb">{`let us know`}</a>{`!`}</p>
    <h2>{`How to integrate diagrams in Jira or Confluence?`}</h2>
    <p>{`GraphUp is perfectly integrated to Jira, Confluence, Notion, GitHub, and other tools you are already using.`}</p>
    <p>{`Use the free online diagrams creator to build you graphs and copy a short url that you can use anywhere.`}</p>
    <h2>{`GraphUp an alternative to draw.io, Google Draw, or Lucidchart?`}</h2>
    <p>{`Yes! And unlike graphical tools, GraphUp frees you from the frustrating tasks of drag-n-dropping things around.`}</p>
    <p>{`Simply write what you need in the graph builder and turn code into SVG images!`}</p>
    <h2>{`How to edit diagrams?`}</h2>
    <p>{`When you upgrade to a `}<Link to="/pricing" mdxType="Link">{`paid plan`}</Link>{` you can edit your diagrams right from GraphUp and have the changes automatically apply
to Jira, Confluence, and any other places that use your diagrams.`}</p>
    <h2>{`How do I remove the watermark?`}</h2>
    <p>{`You can upgrade to a `}<Link to="/pricing" mdxType="Link">{`paid plan`}</Link>{` to remove the watermarks from your diagrams.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      